var map = {
	"./44_pear.mp3": "489a",
	"./45_cherry.mp3": "0108",
	"./49_tomato.mp3": "6ed5",
	"./M_Brilliant.mp3": "822e",
	"./M_Excellent.mp3": "3d93",
	"./M_Fantastic.mp3": "9f10",
	"./M_Great.mp3": "b4a9",
	"./M_Perfect.mp3": "bf75",
	"./M_Think again.mp3": "8ef7",
	"./M_Try again.mp3": "d2a1",
	"./M_Very good.mp3": "8557",
	"./M_Well done.mp3": "ba17",
	"./M_Work harder.mp3": "d1a7",
	"./click.mp3": "9ece",
	"./false.mp3": "8700",
	"./true.mp3": "9863"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b758";